// @flow

import type { HierarchyAssignment } from "@modules/service/types";
import config from "@config";
export const uiSchema = (t: Function) => {
  return {
    "ui:order": ["target", "activeFrom", "activeTo"],
    target: {
      "ui:widget": "text",
      "ui:options": {
        minimum: 1,
        disabled: true,
      },
      "ui:title": t("HIERARCHY_SCOPE_UNIT_NAME"),
    },
    activeFrom: {
      "ui:widget": "date-picker",
      "ui:title": t("HIERARCHY_SCOPE_START_DATE"),
      "ui:options": {
        dateFormat: "DD/MM/YYYY",
        required: true,
        minimum: 1,
        dateFormat: config.dateFormatBE,
      },
    },
    activeTo: {
      "ui:widget": "date-picker",
      "ui:title": t("HIERARCHY_SCOPE_END_DATE"),
      "ui:options": {
        dateFormat: "DD/MM/YYYY",
        minimum: 1,
        dateFormat: config.dateFormatBE,
        minDate: (item: HierarchyAssignment) => new Date(item.activeFrom),
      },
    },
  };
};
